<template>
  <p v-html="content" />
</template>

<script>
export default {
  name: 'Paragraph',
  props: {
    content: {
      type: String,
      required: true
    }
  }
}
</script>
